import { styled } from '@mui/material/styles';

import { Paper } from 'shared/components/Paper';

export const DialogPaper = styled(Paper)(({ theme }) => ({
  width: '90%',
  maxWidth: '600px',
  padding: theme.spacing(1),
}));
